export const DealerListSuccess = 'ALL_DEALER_LIST_SUCCESS';
export const ALlAssignDealerListSuccess = 'ALL_Assign_DEALER_LIST_SUCCESS';

export function setAllDealerListAction(data) {
  return {
    type: DealerListSuccess,
    payload: data,
  };
}
export function setAllAssignDealerListAction(data) {
  return {
    type: ALlAssignDealerListSuccess,
    payload: data,
  };
}
